// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InOutAssetDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class InOutAssetApiClient extends BaseCRUDApiClient<InOutAssetDto> {
  baseUrl = this.config.apiEndpoint + '/in-out-asset';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
